(function($)
{
    var
        classErrorInvalid = 'invalid',
        classErrrorMissing = 'missing',
        classErrorRequirements = 'requirements';

    $.extend(true, orion, {
        validation: {}
    });

    function not(f)
    {
        return function()
        {
            return !f.apply(this);
        };
    }

    function and(f, g)
    {
        return function()
        {
            return f.apply(this) && g.apply(this);
        };
    }

    function isEmpty()
    {
        return $(this).val().length === 0;
    }

    function dateInputIsComplete()
    {
        var
            $input = $(this),
            dateGroup = $input.data('date-group'),
            $day, $month, $year;

        $day = $('input[type=number][data-date-group=' + dateGroup + '][data-date-role=day],'
			+ ' select[data-date-group=' + dateGroup + '][data-date-role=day]');
        if ($day.length !== 1 || 0 === $day.val().length)
        {
            return false;
        }

        $month = $('input[type=number][data-date-group=' + dateGroup + '][data-date-role=month],'
			+ ' select[data-date-group=' + dateGroup + '][data-date-role=month]');
        if ($month.length !== 1 || 0 === $month.val().length)
        {
            return false;
        }

        $year = $('input[type=number][data-date-group=' + dateGroup + '][data-date-role=year],'
			+ ' select[data-date-group=' + dateGroup + '][data-date-role=year]');
        if ($year.length !== 1 || 0 === $year.val().length)
        {
            return false;
        }

        return true;
    }

    function dateInputMMYYIsComplete()
    {
        var
            $input = $(this),
            dateGroup = $input.data('date-group-mm-yy'),
            $month, $year;

        $month = $('input[type=number][data-date-group-mm-yy=' + dateGroup + '][data-date-role=month],'
			+ ' select[data-date-group-mm-yy=' + dateGroup + '][data-date-role=month]');
        if ($month.length !== 1 || 0 === $month.val().length)
        {
            return false;
        }

        $year = $('input[type=number][data-date-group-mm-yy=' + dateGroup + '][data-date-role=year],'
			+ ' select[data-date-group-mm-yy=' + dateGroup + '][data-date-role=year]');
        if ($year.length !== 1 || 0 === $year.val().length)
        {
            return false;
        }

        return true;
    }

    function _makeDateFromGroup(input)
    {
        var
            $input = $(input),
            dateGroup = $input.data('date-group'),
            $day, $month, $year,
            day, month, year,
            error = false;

        $day = $('input[type=number][data-date-group=' + dateGroup + '][data-date-role=day],'
			+ ' select[data-date-group=' + dateGroup + '][data-date-role=day]');
        day = parseInt($day.val(), 10);
        if (isNaN(day))
        {
            error = true;
        }

        $month = $('input[type=number][data-date-group=' + dateGroup + '][data-date-role=month],'
			+ ' select[data-date-group=' + dateGroup + '][data-date-role=month]');
        month = parseInt($month.val(), 10);
        if (isNaN(month))
        {
            error = true;
        }

        $year = $('input[type=number][data-date-group=' + dateGroup + '][data-date-role=year],'
			+ ' select[data-date-group=' + dateGroup + '][data-date-role=year]');
        year = parseInt($year.val(), 10);
        if (isNaN(year))
        {
            error = true;
        }

        return {
            'day': day,
            'month': month,
            'year': year,
            'error': error
        };
    }

    function _makeDateFromGroupMMYY(input)
    {
        var
            $input = $(input),
            dateGroup = $input.data('date-group-mm-yy'),
            $month, $year,
            day, month, year,
            error = false;

        day = 1;

        $month = $('input[type=number][data-date-group-mm-yy=' + dateGroup + '][data-date-role=month],'
			+ ' select[data-date-group-mm-yy=' + dateGroup + '][data-date-role=month]');
        month = parseInt($month.val(), 10);
        if (isNaN(month))
        {
            error = true;
        }

        if (month < 0 || month > 11)
        {
            error = true;
        }

        $year = $('input[type=number][data-date-group-mm-yy=' + dateGroup + '][data-date-role=year],'
			+ ' select[data-date-group-mm-yy=' + dateGroup + '][data-date-role=year]');
        year = parseInt($year.val(), 10);
        if (isNaN(year))
        {
            error = true;
        }

        return {
            'day': day,
            'month': month,
            'year': year,
            'error': error
        };
    }

    function dateGroupInputIsValid()
    {
        var
            $input = $(this),
            dateComponents = _makeDateFromGroup($input),
            date = new Date(dateComponents.year, dateComponents.month - 1, dateComponents.day);

        return !date.error
			&& (date.getDate() === dateComponents.day)
			&& (date.getMonth() === dateComponents.month - 1)
			&& (date.getFullYear() === dateComponents.year);
    }

    function dateGroupMMYYInputIsValid()
    {
        var
            $input = $(this),
            dateComponents = _makeDateFromGroupMMYY($input),
            date = new Date(dateComponents.year, dateComponents.month - 1, dateComponents.day);

        return !date.error
			&& (date.getDate() === dateComponents.day)
			&& (date.getMonth() === dateComponents.month - 1)
			&& (date.getFullYear() === dateComponents.year);
    }

    function dateMinAgeInputIsValid()
    {
        var
            $input = $(this),
            dateComponents = _makeDateFromGroup($input),
            date = new Date(dateComponents.year, dateComponents.month - 1, dateComponents.day),
            minAge = parseInt($input.data('date-min-age'), 10),
            now = new Date();

        if (isNaN(minAge))
        {
            return true;
        }

        if (now.getFullYear() - date.getFullYear() > minAge)
        {
            return true;
        }

        if (now.getFullYear() - date.getFullYear() < minAge)
        {
            return false;
        }

        if (now.getMonth() > date.getMonth())
        {
            return true;
        }

        if (now.getMonth() < date.getMonth())
        {
            return false;
        }

        return now.getDate() >= date.getDate();
    }

    function dateNotPastMMYYInputIsValid()
    {
        var
            $input = $(this),
            dateComponents = _makeDateFromGroupMMYY($input),
            date = new Date(dateComponents.year, dateComponents.month - 1, dateComponents.day),
            now = new Date();

        if (now.getFullYear() > date.getFullYear())
        {
            return false;
        }

        if (now.getFullYear() < date.getFullYear())
        {
            return true;
        }

        return now.getMonth() <= date.getMonth();
    }

    function equalToInputIsValid()
    {
        var
            $input = $(this),
            $equal = $('#' + $input.attr('equalto'));

        if (0 === $equal.length)
        {
            return true;
        }

        if (0 === $equal.val().length)
        {
            return true;
        }

        return $input.val() === $equal.val();
    }

    function maxInputIsValid()
    {
        var
            $input = $(this),
            numericValue = parseInt($input.val(), 10),
            numericMax = parseInt($input.attr('max'), 10);

        if (isNaN(numericValue))
        {
            return false;
        }

        if (isNaN(numericMax))
        {
            return true;
        }

        return numericValue <= numericMax;
    }

    function maxLengthInputIsValid()
    {
        var
            $input = $(this),
            numericMaxLength = parseInt($input.attr('maxlength'), 10);

        if (isNaN(numericMaxLength))
        {
            return true;
        }

        return $input.val().length <= numericMaxLength;
    }

    function minInputIsValid()
    {
        var
            $input = $(this),
            numericValue = parseInt($input.val(), 10),
            numericMin = parseInt($input.attr('min'), 10);

        if (isNaN(numericValue))
        {
            return false;
        }

        if (isNaN(numericMin))
        {
            return true;
        }

        return numericValue >= numericMin;
    }

    function minLengthInputIsValid()
    {
        var
            $input = $(this),
            numericMinLength = parseInt($input.attr('minlength'));

        if (isNaN(numericMinLength))
        {
            return true;
        }

        return $input.val().length >= numericMinLength;
    }

    function patternInputIsValid()
    {
        var
            $input = $(this);

        return new RegExp($input.attr('pattern')).test($input.val());
    }

    function requiredInputIsValid()
    {
        var
            $input = $(this);

        if ($input.is(':radio') || $input.is(':checkbox'))
        {
            return $('input[name="' + $input.attr('name') + '"]:checked').length > 0;
        }
        if ($input.hasClass('js-checkbox-group'))
        {
            return $input.find('input[type=checkbox]:checked').length > 0;
        }

        return $input.val().trim().length > 0;
    }

    function stepInputIsValid()
    {
        var
            $input = $(this),
            numericValue = parseInt($input.val()),
            numericMin = parseInt($input.attr('min')),
            numericStep = parseInt($input.attr('step'));

        if (isNaN(numericValue))
        {
            return false;
        }

        if (isNaN(numericMin))
        {
            return true;
        }

        if (isNaN(numericStep))
        {
            return true;
        }

        return (numericValue - numericMin) % numericStep === 0;
    }

    orion.validation.handlers = {
        'dateGroup': {
            'errorClass': classErrorInvalid,
            'failureEvent': 'input-date-group-failed',
            'prerequisites': dateInputIsComplete,
            'selectorInputs': 'input[type=number][data-date-group], select[data-date-group]',
            'validation': dateGroupInputIsValid
        },
        'dateGroupMMYY': {
            'errorClass': classErrorInvalid,
            'failureEvent': 'input-date-group-mm-yy-failed',
            'prerequisites': dateInputMMYYIsComplete,
            'selectorInputs': 'input[type=number][data-date-group-mm-yy], select[data-date-group-mm-yy]',
            'validation': dateGroupMMYYInputIsValid
        },
        'dateMinAge': {
            'errorClass': classErrorRequirements,
            'failureEvent': 'input-date-min-age-failed',
            'prerequisites': and(dateInputIsComplete, dateGroupInputIsValid),
            'selectorInputs': 'input[type=number][data-date-group][data-date-min-age]',
            'validation': dateMinAgeInputIsValid
        },
        'dateNotPastMMYY': {
            'errorClass': classErrorRequirements,
            'failureEvent': 'input-date-not-past-failed',
            'prerequisites': and(dateInputMMYYIsComplete, dateGroupMMYYInputIsValid),
            'selectorInputs': 'input[type-number][data-date-group-mm-yy][data-date-not-past],'
				+ ' select[data-date-group-mm-yy][data-date-not-past]',
            'validation': dateNotPastMMYYInputIsValid
        },
        'equalTo': {
            'errorClass': classErrorRequirements,
            'failureEvent': 'input-equal-to-failed',
            'prerequisites': not(isEmpty),
            'selectorInputs': 'input[equalto]',
            'validation': equalToInputIsValid
        },
        'max': {
            'errorClass': classErrorInvalid,
            'failureEvent': 'input-max-failed',
            'prerequisites': not(isEmpty),
            'selectorInputs': 'input[type=number][max]',
            'validation': maxInputIsValid
        },
        'maxLength': {
            'errorClass': classErrorInvalid,
            'failureEvent': 'input-max-length-failed',
            'prerequisites': not(isEmpty),
            'selectorInputs': 'input[maxlength], textarea[maxlength]',
            'validation': maxLengthInputIsValid
        },
        'min': {
            'errorClass': classErrorInvalid,
            'failureEvent': 'input-min-failed',
            'prerequisites': not(isEmpty),
            'selectorInputs': 'input[type=number][min]',
            'validation': minInputIsValid
        },
        'minLength': {
            'errorClass': classErrorInvalid,
            'failureEvent': 'input-min-length-failed',
            'prerequisites': not(isEmpty),
            'selectorInputs': 'input[minlength], textarea[minlength]',
            'validation': minLengthInputIsValid
        },
        'pattern': {
            'errorClass': classErrorInvalid,
            'failureEvent': 'input-pattern-failed',
            'prerequisites': not(isEmpty),
            'selectorInputs': 'input[pattern], textarea[pattern]',
            'validation': patternInputIsValid
        },
        'required': {
            'errorClass': classErrrorMissing,
            'failureEvent': 'input-required-failed',
            'selectorInputs': 'input[required], input[required-js], select[required],'
				+ ' select[required-js], textarea[required], textarea[required-js], div.js-checkbox-group, '
				+ ' div.js-input-checkbox-group',
            'validation': requiredInputIsValid
        },
        'step': {
            'errorClass': classErrorInvalid,
            'failureEvent': 'input-step-failed',
            'prerequisites': not(isEmpty),
            'selectorInputs': 'input[type=number][min][step]',
            'validation': stepInputIsValid
        }
    };
})(jQuery);
